namespace PaperTrail.NewsletterControl {
    export interface NewsletterRow {
        NewsletterId?: number;
        NewsletterName?: string;
        SubscriptionId?: number;
        SubscriptionName?: string;
        SubscriptionFrequency?: string;
        SubscriptionEditorUserId?: number;
        CreatedBy?: number;
        DateCreated?: string;
        DateModified?: string;
        DatePublish?: string;
        ModifiedBy?: number;
        PageCount?: number;
        StyleSheetId?: number;
        UsersList?: number[];
        SubscriptionUsersList?: number[];
        Stories?: NewsletterStoryRow[];
        PageTemplates?: NewsletterPageTemplateRow[];
        NewsletterAdsList?: number[];
        NewsletterNewsList?: number[];
        ModifiedByUsername?: string;
        ModifiedByDisplayName?: string;
        CreatedByUsername?: string;
        CreatedByDisplayName?: string;
        CreatedByEmail?: string;
        CreatedBySource?: string;
        CreatedByLastDirectoryUpdate?: string;
        CreatedByUserImage?: string;
        CreatedByInsertDate?: string;
        CreatedByInsertUserId?: number;
        CreatedByUpdateDate?: string;
        CreatedByUpdateUserId?: number;
        CreatedByIsActive?: number;
        CreatedByMobilePhoneNumber?: string;
        CreatedByMobilePhoneVerified?: boolean;
        CreatedByTwoFactorAuth?: number;
        StyleSheetTitle?: string;
        StyleSheetFont?: string;
        StyleSheetFontSize?: number;
        StyleSheetTextAlignment?: string;
        StyleSheetHeight?: number;
        StyleSheetWidth?: number;
        StyleSheetPadding?: string;
        StyleSheetMargin?: string;
        StyleSheetRows?: number;
        StyleSheetColumns?: string;
        StyleSheetRotation?: number;
        StyleSheetBackgroundColor?: string;
        StyleSheetForeColor?: string;
        StyleSheetIsUnderline?: boolean;
        StyleSheetIsBold?: boolean;
        StyleSheetIsItalic?: boolean;
    }

    export namespace NewsletterRow {
        export const idProperty = 'NewsletterId';
        export const nameProperty = 'NewsletterName';
        export const localTextPrefix = 'NewsletterControl.Newsletter';
        export const lookupKey = 'NewsletterControl.Newsletter';

        export function getLookup(): Q.Lookup<NewsletterRow> {
            return Q.getLookup<NewsletterRow>('NewsletterControl.Newsletter');
        }
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            NewsletterId = "NewsletterId",
            NewsletterName = "NewsletterName",
            SubscriptionId = "SubscriptionId",
            SubscriptionName = "SubscriptionName",
            SubscriptionFrequency = "SubscriptionFrequency",
            SubscriptionEditorUserId = "SubscriptionEditorUserId",
            CreatedBy = "CreatedBy",
            DateCreated = "DateCreated",
            DateModified = "DateModified",
            DatePublish = "DatePublish",
            ModifiedBy = "ModifiedBy",
            PageCount = "PageCount",
            StyleSheetId = "StyleSheetId",
            UsersList = "UsersList",
            SubscriptionUsersList = "SubscriptionUsersList",
            Stories = "Stories",
            PageTemplates = "PageTemplates",
            NewsletterAdsList = "NewsletterAdsList",
            NewsletterNewsList = "NewsletterNewsList",
            ModifiedByUsername = "ModifiedByUsername",
            ModifiedByDisplayName = "ModifiedByDisplayName",
            CreatedByUsername = "CreatedByUsername",
            CreatedByDisplayName = "CreatedByDisplayName",
            CreatedByEmail = "CreatedByEmail",
            CreatedBySource = "CreatedBySource",
            CreatedByLastDirectoryUpdate = "CreatedByLastDirectoryUpdate",
            CreatedByUserImage = "CreatedByUserImage",
            CreatedByInsertDate = "CreatedByInsertDate",
            CreatedByInsertUserId = "CreatedByInsertUserId",
            CreatedByUpdateDate = "CreatedByUpdateDate",
            CreatedByUpdateUserId = "CreatedByUpdateUserId",
            CreatedByIsActive = "CreatedByIsActive",
            CreatedByMobilePhoneNumber = "CreatedByMobilePhoneNumber",
            CreatedByMobilePhoneVerified = "CreatedByMobilePhoneVerified",
            CreatedByTwoFactorAuth = "CreatedByTwoFactorAuth",
            StyleSheetTitle = "StyleSheetTitle",
            StyleSheetFont = "StyleSheetFont",
            StyleSheetFontSize = "StyleSheetFontSize",
            StyleSheetTextAlignment = "StyleSheetTextAlignment",
            StyleSheetHeight = "StyleSheetHeight",
            StyleSheetWidth = "StyleSheetWidth",
            StyleSheetPadding = "StyleSheetPadding",
            StyleSheetMargin = "StyleSheetMargin",
            StyleSheetRows = "StyleSheetRows",
            StyleSheetColumns = "StyleSheetColumns",
            StyleSheetRotation = "StyleSheetRotation",
            StyleSheetBackgroundColor = "StyleSheetBackgroundColor",
            StyleSheetForeColor = "StyleSheetForeColor",
            StyleSheetIsUnderline = "StyleSheetIsUnderline",
            StyleSheetIsBold = "StyleSheetIsBold",
            StyleSheetIsItalic = "StyleSheetIsItalic"
        }
    }
}
